import React from 'react';
import { LoginPageProps } from '~/pages/LoginPage/LoginPage';
import { ChangePasswordPageProps } from '~/pages/ChangePasswordPage/ChangePasswordPage';
import { ChangePasswordConfirmPageProps } from '~/pages/ChangePasswordConfirmPage/ChangePasswordConfirmPage';
import NotFoundRedirectPage from '~/pages/NotFoundPage/NotFoundRedirectPage';
import { TechnicalErrorPageProps } from '~/pages/TechnicalErrorPage/TechnicalErrorPage';
import { Route } from 'react-router-dom';
import { requestIsFromMobile } from '~/utils/mobileUtils';
import CustomPageLoader from '../components/CustomPageLoader';
import FormLayout from '../layouts/FormLayout/FormLayout';
import MobileLayout from '../layouts/MobileLayout/MobileLayout';
import Constants from './Constants';

const LoginPage = (props: LoginPageProps) => <CustomPageLoader loader={() => import('../pages/LoginPage')} {...props} />;
const ChangePasswordPage = (props: ChangePasswordPageProps) => <CustomPageLoader loader={() => import('../pages/ChangePasswordPage')} {...props} />;
const ChangePasswordConfirmPage = (props: ChangePasswordConfirmPageProps) => <CustomPageLoader loader={() => import('../pages/ChangePasswordConfirmPage')} {...props} />;
const LoggingTestPage = () => <CustomPageLoader loader={() => import('../pages/LoggingTestPage')} />;
const AccessErrorPage = () => <CustomPageLoader loader={() => import('~/pages/AccessErrorPage')} />;
const TechnicalErrorPage = (props: TechnicalErrorPageProps) => <CustomPageLoader loader={() => import('~/pages/TechnicalErrorPage')} {...props} />;
const NotFoundPage = () => <CustomPageLoader loader={() => import('~/pages/NotFoundPage')} />;
const TimeoutErrorPage = () => <CustomPageLoader loader={() => import('~/pages/TimeoutErrorPage')} />;
const LogoffPage = () => <CustomPageLoader loader={() => import('../pages/LogoffPage')} />;

const GetInternalRoute = (route: string) => {
  const queryParams = new URLSearchParams(window.location.search);
  const displayForMobile = requestIsFromMobile(queryParams) || sessionStorage.getItem('mobileDeviceMode') === 'true';
  const fromURI = queryParams.get('fromURI');

  if (fromURI) {
    sessionStorage.setItem('fromURI', fromURI);
  }

  switch (route) {
    case Constants.Pages.home:
      return (
        <Route
          path={Constants.Pages.home}
          element={
            displayForMobile ?
              <MobileLayout>
                <LoginPage mobileDeviceMode />
              </MobileLayout>
              :
              <FormLayout>
                <LoginPage mobileDeviceMode={false} />
              </FormLayout>
          }
        />
      );
    case Constants.Pages.changePassword:
      return (
        <Route
          path={Constants.Pages.changePassword}
          element={
            displayForMobile ?
              <MobileLayout>
                <ChangePasswordPage mobileDeviceMode />
              </MobileLayout>
              :
              <FormLayout>
                <ChangePasswordPage mobileDeviceMode={false} />
              </FormLayout>
          }
        />
      );
    case Constants.Pages.changePasswordConfirm:
      return (
        <Route
          path={Constants.Pages.changePasswordConfirm}
          element={
            displayForMobile ?
              <MobileLayout>
                <ChangePasswordConfirmPage mobileDeviceMode />
              </MobileLayout>
              :
              <FormLayout>
                <ChangePasswordConfirmPage mobileDeviceMode={false} />
              </FormLayout>
          }
        />
      );
    case Constants.Pages.loggingTest:
      return (
        <Route
          path={Constants.Pages.loggingTest}
          element={
            <FormLayout>
              <LoggingTestPage />
            </FormLayout>
          }
        />
      );
    case Constants.Pages.accessError:
      return (
        <Route
          path={Constants.Pages.accessError}
          element={
            <FormLayout>
              <AccessErrorPage />
            </FormLayout>
          }
        />
      );
    case Constants.Pages.technicalError:
      return (
        <Route
          path={Constants.Pages.technicalError}
          element={
            <FormLayout>
              <TechnicalErrorPage />
            </FormLayout>
          }
        />
      );
    case Constants.Pages.technicalErrorWithLogoff:
      return (
        <Route
          path={Constants.Pages.technicalErrorWithLogoff}
          element={
            <FormLayout>
              <TechnicalErrorPage redirectUrl={Constants.Pages.logOff} />
            </FormLayout>
          }
        />
      );
    case Constants.Pages.notFound:
      return (
        <Route
          path={Constants.Pages.notFound}
          element={
            <FormLayout>
              <NotFoundPage />
            </FormLayout>
          }
        />
      );
    case Constants.Pages.timeoutError:
      return (
        <Route
          path={Constants.Pages.timeoutError}
          element={
            <MobileLayout>
              <TimeoutErrorPage />
            </MobileLayout>
          }
        />
      );
    case Constants.Pages.logOff:
      return (
        <Route
          path={Constants.Pages.logOff}
          element={
            <LogoffPage />
          }
        />
      );
    default:
      return (
        <Route
          path={Constants.Pages.catchAll}
          element={
            <NotFoundRedirectPage />
          }
        />
      );
  }
};

export default GetInternalRoute;
